import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "truncate w-full"
}
const _hoisted_2 = ["title"]
const _hoisted_3 = { key: 2 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "mt-2 h-4 rounded-full bg-gray-300 animate-pulse w-full" }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]

import { 
		localesStore
	} from '@/store/locales'


	import {
		computed
	} from "vue"

	
export default /*#__PURE__*/_defineComponent({
  __name: 'DataDisplay',
  props: { 
		label: {
			type: String,
			default: ''
		},
		loading: {
			type: Boolean,
			default: false
		},
		editing: {
			type: Boolean,
			default: false
		},
		placeholder: {
			type: String,
			default: '—'
		},
		value: {
			type: [ String, Number ],
			default: null
		},
		valueClass: {
			type: String,
			default: ''
		},
		labelClass: {
			type: String,
			default: ''
		},
		badge: {
			type: Boolean,
			default: false
		}
	},
  setup(__props) {


	const placeholderValue = computed(() => {
		let value: string|number = props.value ?? props.placeholder
		if((!value && (!(value === 0))) || (String(value).includes("undefined"))) {
			return null
		}
		else{
			return value
		}
		
	})

	const _localesStore = localesStore()
	
	const props = __props
	

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("dt", {
      class: _normalizeClass(["text-sm font-medium", [__props.labelClass, _unref(_localesStore).locales.selected == 'en' ? 'text-gray-500' : 'text-black']])
    }, _toDisplayString(props.label), 3),
    _withDirectives(_createElementVNode("div", null, [
      (_ctx.$slots.custom)
        ? (_openBlock(), _createElementBlock("dd", _hoisted_1, [
            _renderSlot(_ctx.$slots, "custom")
          ]))
        : (!__props.editing)
          ? (_openBlock(), _createElementBlock("dd", {
              key: 1,
              title: placeholderValue.value,
              class: _normalizeClass([[__props.valueClass, props.value === null || props.value === undefined || props.value === '' ? 'text-gray-300' : 'text-gray-800'], "text font-medium truncate w-full"])
            }, _toDisplayString(placeholderValue.value), 11, _hoisted_2))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _renderSlot(_ctx.$slots, "default")
            ]))
    ], 512), [
      [_vShow, !__props.loading]
    ]),
    _withDirectives(_createElementVNode("div", null, _hoisted_5, 512), [
      [_vShow, __props.loading]
    ])
  ], 64))
}
}

})